import {Text, Float} from "@react-three/drei"
import {colors} from "../../utils/constants"
import { isMobile } from "react-device-detect";

function CustomTexts() {
  return (
    <>
      <Text
        font="/assets/fonts/Inter-Bold.woff"
        color={"#E5E7E9"}
        maxWidth={3}
        anchorX="center"
        anchorY="top"
        position={[0, 3.4, 0]}
        fontSize={0.2}
      >
        From the PepeCoin team.
      </Text>
      <Float
        speed={1} // Animation speed, defaults to 1
        rotationIntensity={0.3} // XYZ rotation intensity, defaults to 1
        floatIntensity={0.7} // Up/down float intensity, works like a multiplier with floatingRange,defaults to 1
        floatingRange={[0.1, -0.3]} // Range of y-axis values the object will float within, defaults to [-0.1,0.1]
      >
        <Text
          outlineWidth={0.2}
          outlineColor={"#DAB8A8"}
          color={colors.green}
          font="/assets/fonts/Inter-Bold.woff"
          maxWidth={3}
          anchorX="center"
          anchorY="top"
          position={[0, 3.1, 0]}
          fontSize={1.2}
        >
          ABOUT
        </Text>

        <Text
          outlineWidth={0.09}
          outlineColor={"#DAB8A8"}
          color={colors.green}
          font="/assets/fonts/Inter-Bold.woff"
          maxWidth={3}
          anchorX="center"
          anchorY="top"
          position={[0, 1.6, 0]}
          fontSize={0.5}
        >
          PEPE3D
        </Text>
      </Float>
      <Text
        maxWidth={1}
        anchorX="center"
        anchorY="top"
        textAlign="center"
        position={isMobile ?[0, 0.3, 6.5]: [0,0.3,1]}
        fontSize={0.1}
        depthOffset={1}
      >
        Click on images to view details
      </Text>
    </>
  );
}

export default CustomTexts